import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faPrint, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import PDFHistoriasClinicas from './PDFHistoriasClinicas';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        filename: '',
        historiasClinicas: [],
        historiaClinicaData: []
    }

    ListarHistoriasClinicas(page) {
        Swal.showLoading();
        let bname = document.getElementById('bname').value;
        let btype = document.getElementById('btype').value;
        if (bname == '') {
            bname = 0;
        }
        if (btype == '') {
            btype = 0;
        }
        authAxios.get("historias_clinicas/index/" + btype + "/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    historiasClinicas: dataResult.data.data,
                    page: dataResult.data.total,
                    last: dataResult.data.last_page,
                    current: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    previewPDFHistoriasClinicas = (id_historia_clinica) => {
        authAxios.get(`historias_clinicas/generar_historia_clinica/${id_historia_clinica}`)
            .then((dataResult) => {
                console.log(dataResult);
                var status = dataResult.data.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }         
                const filename = `Dents - Historia Clínica #${dataResult.data.historia_clinica.ID_HISTORIA_CLINICA}.pdf`
                this.setState({
                    historiaClinicaData: dataResult.data,
                    filename: filename
                });
            })
            .catch((error) => console.log(error))
    }
    componentDidMount() {
        this.ListarHistoriasClinicas(1);
    }
    render() {
        const { load, filename, historiasClinicas, historiaClinicaData, page, last, current } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br/>
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddHistoriasClinicas"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Historia Clínica</Link>
                        </div>
                        <div className="card-body">
                            <h4>Listas de Historias Clínicas</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btype" id="btype"
                                        className={"form-select form-select-sm"}>
                                        <option value="">-</option>
                                        <option value="1">PACIENTE</option>
                                        <option value="2">IDENTIFICACIÓN</option>
                                    </select>
                                </div>
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Buscar Paciente" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarHistoriasClinicas(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle"># HIST. CLÍNICA</th>
                                                <th className="align-middle">PACIENTE</th>
                                                <th className="align-middle">IDENTIFICACIÓN</th>
                                                <th className="align-middle">CELULAR</th>
                                                <th className="align-middle">ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                historiasClinicas.map((itemHistoriasClinicas) => (
                                                    <tr key={itemHistoriasClinicas.ID_HISTORIA_CLINICA}>
                                                        <td>{itemHistoriasClinicas.ID_HISTORIA_CLINICA}</td>
                                                        <td>{itemHistoriasClinicas.NOMBRE_PACIENTE}</td>
                                                        <td>{itemHistoriasClinicas.IDENTIFICACION}</td>
                                                        <td>{itemHistoriasClinicas.CELULAR}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpHistoriasClinicas/" + itemHistoriasClinicas.ID_HISTORIA_CLINICA}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>
                                                                {/* <button
                                                                    type="button"
                                                                    className="btn btn-secondary btn-sm"
                                                                    data-bs-toggle='modal'
                                                                    data-bs-target="#PDFHistoriasClinicasModal"
                                                                    slot='end'
                                                                    onClick={() => {
                                                                        this.previewPDFHistoriasClinicas(itemHistoriasClinicas.ID_HISTORIA_CLINICA)
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={faPrint} />
                                                                </button> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarHistoriasClinicas(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarHistoriasClinicas(current - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={current}><a className="page-link" href="#" onClick={() => this.ListarHistoriasClinicas(current)}>{current}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarHistoriasClinicas(current + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarHistoriasClinicas(last)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Página</b> <span className="badge bg-primary">{current}</span> <b>de</b> <span className="badge bg-primary">{last}</span> | <b>Registros</b> <span className="badge bg-success">{page}</span>
                        </div>
                    </div>
                </div>
                {/* Modals */}
                <div className="modal fade" id="PDFHistoriasClinicasModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PDFHistoriasClinicasModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className='col-9'>
                                    <h4 className="modal-title w-100 text-center" id="">Historias Clínicas</h4>
                                </div>
                                <div className='col-2'>
                                    <PDFDownloadLink
                                        document={<PDFHistoriasClinicas data={historiaClinicaData} />}
                                        fileName={filename}
                                    >
                                        {({ loading }) =>
                                            loading ? "Loading..." : <button className="btn btn-success"> Download PDF <FontAwesomeIcon icon={faPrint} /></button>
                                        }
                                    </PDFDownloadLink>
                                </div>
                                <div className='col-1'>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <PDFViewer style={{ width: "100%", height: "90vh" }}>
                                            <PDFHistoriasClinicas data={historiaClinicaData} />
                                        </PDFViewer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;